import {h, Fragment} from "preact"
import { useResponse, AutocompleteElement, Keywords, useCurrencyFormatting, useAppStateSelector, pick } from "@nosto/preact"
import { productImagePlaceholder, injectProductScripts, matchHeight } from "../helpers"
import SubmitButton from "./elements/SubmitButton"
import { useEffect, useMemo } from "preact/hooks"

export default function Autocomplete() {
    const { products, keywords } = useResponse()
    const { query } = useAppStateSelector(state => pick(state, "query") )
    const { format } = useCurrencyFormatting()

    if (!products?.hits?.length && !keywords?.hits?.length) {
        return
    }

    return (
        <div
            class="ns-autocomplete ns-absolute ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white ns-border-box ns-mx-auto"
            data-nosto-element="autocomplete"
        >
            <div class="ns-w-100 ns-mt-sm-auto">
                <div class="ns-d-flex ns-flex-column ns-flex-sm-row-reverse">
                    {keywords?.hits?.length > 0 && (
                        <div
                            class={`ns-autocomplete-keywords ns-d-flex ns-flex-column ns-col-12 ${
                                products?.hits?.length > 0 ? "ns-col-sm-4" : "ns-col-sm-12"
                            }`}
                        >
                            <h5 class="ns-color-black ns-header"> Suggestions </h5>
                            <div class="ns-d-flex ns-flex-column">
                                <Keywords
                                    hits={keywords.hits}
                                    keywordComponent={Keyword}
                                    elementComponent={Element}
                                    keywordInCategoryComponent={KeywordInCategory}
                                />
                            </div>
                        </div>
                    )}
                    {products?.hits?.length > 0 && (
                        <div class="ns-autocomplete-products ns-d-flex ns-flex-column ns-flex-grow-1" style="border-right-color: #e3e3e3;">
                            <SubmitButton text="See All Search Results >" query={query?.query} />
                            {/* <h5 class="ns-color-black ns-px-4"> Products </h5> */}
                            <div class="productgrid--items" id="nosto-ac-template">
                                {products?.hits?.map(product => {

                                    const limitedEdition = useMemo(() => product?.tags1?.find(tag => tag.includes('limited edition')), [products])
                                    const productHandle = useMemo(() => product?.url?.split("/")?.pop(), [products])
                                    const sizeBadge = useMemo(() => product?.tags1?.find(tag => tag.includes('Size_'))?.split("_").pop(), [products])

                                    injectProductScripts(productHandle, product.productId).then((data) => {
                                        data = JSON.parse(data.innerHTML);
                                
                                        var itm = new window.ProductGridItem({
                                            $el:  jQuery(`.ns-product-${product.productId}`),
                                            id: 'nosto-ac-template',
                                            product: data,
                                            lazy: true
                                        })
                                    })

                                    useEffect(() => {
                                        matchHeight(".ns-autocomplete .ns-product .productitem--info");
                                        window.addEventListener("resize", function () {
                                            matchHeight(".ns-autocomplete .ns-product .productitem--info");
                                        });

                                    }, [products])

                                    return (
                                        <AutocompleteElement
                                            as="li"
                                            key={product.productId} 
                                            hit={product}
                                            ariaLabel={`Product ${product.name}`}
                                            class={`ns-product ns-product-${product.productId} ns-border-box ns-clickable ns-text-undecorated ns-color-inherit productgrid--item imagestyle--medium show-actions--mobile`}
                                        >
                                            {/* {productHandle && injectProductScripts(product)} */}
                                            <article class={`productitem ${product.onDiscount ? 'productitem--sale' : ''}`}>
                                                {limitedEdition && <img class="badge--limitededition" src="https://cdn.shopify.com/s/files/1/0043/9258/3217/files/Limited_Edition_Badge_200x200_crop_center.png" />}
                                                <a class="productitem--image-link" href={product.url} tabindex="-1" data-product-page-link="true">
                                                    <figure class="productitem--image" data-product-item-image="true">
                                                        <img
                                                            class="productitem--image-primary"
                                                            src={product.imageUrl ?? productImagePlaceholder}
                                                            alt={product.name}
                                                            title={product.name}
                                                            loading="lazy"
                                                        />
                                                        {product.availability == "OutOfStock" && <span class="productitem--badge badge--soldout">Sold Out</span>}
                                                        {product.onDiscount && <span class="productitem--badge badge--sale">Sale</span>}
                                                        {sizeBadge && sizeBadge != "700ml" && sizeBadge != "750ml" && <span class="productitem--badge badge--size ns-size-badge">{sizeBadge}</span>}
                                                    </figure>
                                                </a>
                                                <div class="productitem--info">
                                                    <h2 class="productitem--title">
                                                        <a href={product.url} data-product-page-link="true">{product.name}</a>
                                                    </h2>
                                                    <div class="productitem--price">
                                                        <div class="productitem--price">
                                                            <div class={`price--compare-at ${product.onDiscount ? 'visible' : ''}`} data-price-compare-at="true">
                                                                <span class="visually-hidden">Original Price</span>
                                                                {product.onDiscount ? <span class="money">{format(product.listPrice)}</span> : <span class="money">$0.00</span>}
                                                            </div>
                                                            <div class="price--main" data-price="true">
                                                                <span class="money">{format(product.price)}</span>
                                                            </div>
                                                            <div class=" product__unit-price hidden " data-unit-price="true">
                                                                <span class="product__total-quantity" data-total-quantity="true"></span> 
                                                                |<span class="product__unit-price-amount money" data-unit-price-amount="true"></span> 
                                                                / <span class="product__unit-price-measure" data-unit-price-measure="true"></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="productitem--description">
                                                        <a class="productitem--link" data-product-page-link="true" href={product.url}>View full details</a>
                                                    </div>
                                                </div>
                                                <div class="productitem--actions" data-product-actions="true" data-product-actions-id={product.productId}>
                                                    <div class="productitem--listview-price">
                                                        <div class="productitem--price">
                                                            <div class="price--compare-at" data-price-compare-at="true">
                                                                <span class="visually-hidden">Original Price</span>
                                                                <span class="money">$0.00</span>
                                                            </div>
                                                            <div class="price--main" data-price="true">
                                                                <span class="money">{format(product.price)}</span>
                                                            </div>
                                                            <div class=" product__unit-price hidden " data-unit-price="true">
                                                                <span class="product__total-quantity" data-total-quantity="true"></span>
                                                                | <span class="product__unit-price-amount money" data-unit-price-amount="true"></span> 
                                                                / <span class="product__unit-price-measure" data-unit-price-measure="true"></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* <div class=" productitem--action quickshop-button">
                                                        <button class="productitem--action-trigger productitem--action-atc button-primary" type="button" aria-label="Add to cart" data-quick-buy="true" onClick={(e) => addToCart(e, product.skus[0]?.id)} data-variant-id={product.skus[0]?.id}>
                                                            <span class="atc-button--text">Add to cart</span>
                                                            <span class="atc-button--icon">
                                                                <svg class="icon-spinner " aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                                                                    <title>Spinner icon</title>
                                                                    <circle opacity="0.29" cx="13" cy="13" r="11" stroke="currentColor" stroke-width="2"></circle>
                                                                    <path d="M24 13C24 19.0751 19.0751 24 13 24" stroke="currentColor" stroke-width="2"></path>
                                                                </svg>
                                                            </span>
                                                        </button>
                                                    </div> */}
                                                    <div class=" productitem--action atc--button ">
                                                        <button class="productitem--action-trigger productitem--action-qs button-secondary" data-quickshop-trigger="full" type="button">Quick shop</button>
                                                    </div>
                                                </div>
                                            </article>
                                            <div class="productitem-quickshop" data-product-quickshop={product.productId} data-product-quickshop-url={product.url} data-product-quickshop-hash={`${product.productId}-collection`}></div>
                                        </AutocompleteElement>
                                    )
                                })}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

function Keyword({ hit }) {
    return (
        <span data-nosto-element="keyword">
            {hit?._highlight?.keyword ? (
                <span
                    dangerouslySetInnerHTML={{
                        __html: hit._highlight.keyword
                    }}
                ></span>
            ) : (
                hit.keyword
            )}
        </span>
    )
}

function Element({ hit, keywordComponent, filter }) {
    return (
        <AutocompleteElement hit={hit} filter={filter} class="ns-clickable ns-py-2 ns-keyword">
            {keywordComponent}
        </AutocompleteElement>
    )
}

function KeywordInCategory({ category, children }) {
    return (
        <span class="ns-clickable">
            {category?.value ? (
                <span>
                    {children}{" "}
                    <span class="ns-keyword-in-category">
                        in <span>{category.value}</span>
                    </span>
                </span>
            ) : (
                children
            )}
        </span>
    )
}
